

import React, { useState, useEffect } from "react";
import "../circle/circleDinamic.css";
import { FaArrowDown } from "react-icons/fa";

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);//asegura que un valor siempre va estar en entre min y max
                                                                    //se usa para evitar que el circulo se haga muy grande o muy pequeño
const Circle = ({ triggerRef, footerRef }) => {  //tiggerRef hace referencia a la seccion usSection y footerRef al footer
  const [scale, setScale] = useState(0.9); // escala mínima

  useEffect(() => {       //se monta el listener de scroll
    const handleScroll = () => {   //se ejecuta con el scroll
      if (!triggerRef.current) return;

      const minScale = 0.9;

      // Detectar si es mobile
      const isMobile = window.innerWidth <= 768;
      const maxScale = isMobile ? 15 : 60; // escala máxima menor en mobile

      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const viewportMiddle = scrollY + windowHeight / 2;

      const triggerTop = triggerRef.current.offsetTop;
      const triggerHeight = triggerRef.current.offsetHeight;

      let newScale = minScale;

      // Dentro de la UsSection -> crecer rápido
      if (viewportMiddle >= triggerTop && viewportMiddle <= (triggerTop + triggerHeight)) {
        const progress = (viewportMiddle - triggerTop) / triggerHeight;
        const fastProgress = Math.pow(progress, 0.2); // crece rápido al entrar
        newScale = minScale + fastProgress * (maxScale - minScale);
      } 
      else if (viewportMiddle < triggerTop) {
        newScale = minScale;
      } 
      else {
        // Entre final de UsSection y footer -> contraer
        if (footerRef?.current) {
          const footerTop = footerRef.current.offsetTop;

          if (viewportMiddle >= footerTop) {
            newScale = minScale;
          } else {
            const start = triggerTop + triggerHeight;
            const end = footerTop;
            const total = Math.max(1, end - start);
            const dist = Math.max(0, end - viewportMiddle);
            const factor = clamp(dist / total, 0, 1);
            newScale = minScale + Math.pow(factor, 1.5) * (maxScale - minScale);
          }
        } else {
          newScale = minScale + (maxScale - minScale) / 2;
        }
      }

      setScale(newScale);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll); // recalcular al redimensionar
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [triggerRef, footerRef]);

  return (
    <div className="circle-container">
      <div
        className="circle-dynamic"
        style={{ transform: `translate(-50%, -50%) scale(${scale})` }}
      ></div>
      <div className="arrow-down">
        <FaArrowDown size={30} color="white" />
      </div>
    </div>
  );
};

export default Circle;
